import React from "react";
import { Col, Row } from "react-bootstrap";
import activiti1 from "../Images/Activities/activiti1.jpg";
import activiti2 from "../Images/Activities/activiti2.jpg";
import activiti3 from "../Images/Activities/activiti3.jpg";
import activiti4 from "../Images/Activities/activiti4.jpg";
import activiti15 from "../Images/Activities/activiti15.jpg";
import activiti16 from "../Images/Activities/activiti16.jpg";
import activiti17 from "../Images/Activities/activiti17.jpg";
import activiti18 from "../Images/Activities/activiti18.jpg";
import activiti19 from "../Images/Activities/activiti19.jpg";
import activiti110 from "../Images/Activities/activiti110.jpg";

const Activities = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Activities</h1>
        <Row className="mt-5">
          <h3 className="mt-3">Womens Day March 2024</h3>
          <br />
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0 ">
            <img src={activiti1} className="w-100 img-fluid" alt="" />
          </Col>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti2} className="w-100 img-fluid" alt="" />
          </Col>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti3} className="w-100 img-fluid" alt="" />
          </Col>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti4} className="w-100 img-fluid" alt="" />
          </Col>
        </Row>
        <Row className="mt-3">
          <h3 className="mt-3">General Meeting 2024</h3>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti15} className="w-100 img-fluid" alt="" />
          </Col>
        </Row>
        <Row className="mt-3">
          <h3 className="mt-3">Ambedkar Jayanti 2024</h3>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti16} className="w-100 img-fluid" alt="" />
          </Col>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti17} className="w-100 img-fluid" alt="" />
          </Col>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti18} className="w-100 img-fluid" alt="" />
          </Col>
          <Col md={3} sm={10} className="mt-sm-2 mt-md-0">
            <img src={activiti19} className="w-100 img-fluid" alt="" />
          </Col>
          <br />
          <Col md={3} sm={10} className="mt-md-3 mt-sm-2">
            <img src={activiti110} className="w-100 img-fluid" alt="" />
          </Col>
        </Row>
      </section>
    </>
  );
};

export default Activities;
